import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

export type FlowStep = 1 | 2 | 3;

interface FlowStepBadgeProps {
  step: FlowStep;
  showLabel?: boolean;
}

const stepConfig: Record<FlowStep, { color: string; bgColor: string; label: string; tooltip: string }> = {
  1: {
    color: '#1565c0',
    bgColor: '#e3f2fd',
    label: 'Paso 1',
    tooltip: 'Guía de Materia Prima - Primer paso del flujo de producción'
  },
  2: {
    color: '#2e7d32',
    bgColor: '#e8f5e9',
    label: 'Paso 2',
    tooltip: 'Guía de Producción - Segundo paso del flujo de producción'
  },
  3: {
    color: '#7b1fa2',
    bgColor: '#f3e5f5',
    label: 'Paso 3',
    tooltip: 'Parte de Producción - Tercer paso del flujo de producción'
  }
};

export const FlowStepBadge: React.FC<FlowStepBadgeProps> = ({ step, showLabel = true }) => {
  const config = stepConfig[step];

  return (
    <Tooltip title={config.tooltip} arrow>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          backgroundColor: config.bgColor,
          borderRadius: '16px',
          px: 1.5,
          py: 0.5,
          border: `1px solid ${config.color}30`,
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: config.color,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: '0.85rem',
          }}
        >
          {step}
        </Box>
        {showLabel && (
          <Typography
            variant="caption"
            sx={{
              color: config.color,
              fontWeight: 600,
              fontSize: '0.75rem',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {config.label}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default FlowStepBadge;
